export default {
  closeLabel: {
    id: 'rm_detail_header_close',
    defaultMessage: 'Close',
  },
} as const
